import { FC, memo, ReactElement } from 'react';
import { useQueryClient } from 'react-query';

import { useAppModalControls } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { SitesArchivesList, SitesUploadArchive, useGetContentByIdSitesQuery, useUpdateArchiveUploadStatus } from '@/modules/Sites';

import { SitesOverviewView } from './SitesOverviewView';


interface Props {
  siteId: string;
}

export const SitesOverviewContainer: FC<Props> = memo(({ siteId }) => {
  const queryClient = useQueryClient();
  const [archivesListModalControls] = useAppModalControls();
  const [uploadArchiveModalControls] = useAppModalControls();

  const {
    data: siteData,
    error: siteError,
    isLoading: isSiteLoading,
    isError: isSiteError,
    isSuccess: isSiteRequestSuccess
  } = useGetContentByIdSitesQuery(siteId)({
    enabled: !!siteId
  });

  useUpdateArchiveUploadStatus({ queryClient, siteId, isSiteRequestSuccess });

  return (
    <FallbackedLayout
      data={ siteData }
      error={ siteError }
      isError={ isSiteError }
      isLoading={ isSiteLoading }
    >
      {
        (site): ReactElement => (
          <>
            <SitesArchivesList
              modalControls={ archivesListModalControls }
              siteId={ siteId }
            />

            <SitesUploadArchive
              modalControls={ uploadArchiveModalControls }
              siteId={ siteId }

            />
            <SitesOverviewView
              site={ site }
              sitesUploadArchivesModalOpen={ archivesListModalControls.open }
              sitesUploadArchiveModalOpen={ uploadArchiveModalControls.open }
              disableButtons={ false }
            />
          </>
        )
      }
    </FallbackedLayout>
  );
});
